(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/assets/javascripts/helpers/board-descriptions.js') >= 0) return;  svs.modules.push('/components/numbergames/game/assets/javascripts/helpers/board-descriptions.js');

'use strict';

const phrases = ['Angenämt!', 'Bravo!', 'Bra!', 'Bra jobbat!', 'Bra val!', 'Bravissimo!', 'Briljant!', 'BANG!', 'Charmant!', 'Cool!', 'Där satt den!', 'Enastående!', 'Eminent!', 'Excellent!', 'Fantastisk!', 'Finemang!', 'Finfin!', 'Formidabel!', 'Framstående!', 'Fräsch!', 'Förträfflig!', 'Förstklassig!', 'Galant!', 'Glimrande!', 'Hurra!', 'Hyvens!', 'Härligt!', 'Håll tummarna!', 'Jippie!', 'Kalasrad!', 'Klart!', 'Lycka till!', 'Lysande!', 'Läckert!', 'Magnifikt!', 'Nu så…!', 'Pangrad!', 'Perfekt!', 'Prima!', 'Snyggt!', 'Stjärnklart!', 'Strong!', 'Strålande!', 'Superb!', 'Suverän!', 'Sylvass!', 'Tiptop!', 'Toppen!', 'Underbart!', 'Utmärkt!', 'Utsökt!', 'Utomordentlig!', 'Världsklass!', 'Whop whop!', 'Wow!', 'Yes!'];
function singleSelectionText(_ref) {
  let {
    remaining,
    numberType = 'nummer'
  } = _ref;
  if (remaining) {
    return "V\xE4lj ".concat(remaining, " ").concat(numberType);
  }
  return phrases[Math.floor(Math.random() * phrases.length)];
}
function systemSelectionText(_ref2) {
  let {
    size,
    min,
    max,
    numberType = 'nummer'
  } = _ref2;
  const minToMax = min === max ? min : "".concat(min, " till ").concat(max);
  const selectionText = max === 0 ? "V\xE4lj ".concat(numberType) : "V\xE4lj ".concat(minToMax, " ").concat(numberType);
  return size ? "".concat(size, " nummer (").concat(selectionText, ")") : selectionText;
}
function numbersBoardHeader(_ref3) {
  let {
    isSystem,
    rules,
    rowCount,
    numbers,
    numbersExtra,
    level,
    isValid
  } = _ref3;
  if (isSystem) {
    if (isValid && !numbersExtra) {
      return svs.numbergames.rules.system.systemDescription({
        rowCount,
        level,
        numbersLength: numbers.length
      });
    }
    const limits = svs.numbergames.rules.system.systemNumbersLimits({
      rules,
      combinationSize: numbersExtra && numbersExtra.length,
      level
    });
    return systemSelectionText({
      size: numbers.length,
      min: limits.min,
      max: limits.max
    });
  }
  return singleSelectionText({
    remaining: numbers.remaining()
  });
}
function numbersExtraBoardHeader(_ref4) {
  let {
    isSystem,
    rules,
    productId,
    numbers,
    numbersExtra
  } = _ref4;
  const extraNumberType = {
    EUROJACKPOT: 'stjärnnummer',
    VIKINGLOTTO: 'vikingnummer'
  };
  const numberType = extraNumberType[productId];
  if (isSystem) {
    const limits = svs.numbergames.rules.system.systemNumbersExtraLimits({
      rules,
      combinationSize: numbers.length
    });
    return systemSelectionText({
      size: numbersExtra.length,
      min: limits.min,
      max: limits.max,
      numberType
    });
  }
  return singleSelectionText({
    remaining: numbersExtra.remaining(),
    numberType
  });
}
svs.numbergames.game.helpers.boardDescriptions = {
  numbersBoardHeader,
  numbersExtraBoardHeader
};

 })(window);